<template>
    <div class="mobileScene-page">
        <!-- 移动端 -->
        <div class="mobileScene visible-sm-and-down">
            <div class="mobileScene-scene">
                <div class="mobileScene-scene-part" v-for="item in prolist" :key="item.uuid" v-show="industryType===item.industryType">
                    <img :src="item.industryPicEntityList?item.industryPicEntityList[0].requestPath:''" alt="交通" style="width: 100%;">
                    <div class="product-title">
                        <div>{{item.title}}</div>
                        <div>{{item.industryPicEntityList?item.industryPicEntityList[0].content:''}}</div>
                    </div>
                </div>
            </div>

            <div class="mobileScene-main" v-for="item in proChildList" :key="item.uuid">
                <div class="mobileScene-sceneIntro">
                    <div class="mobileScene-sceneIntro-title">{{item.title}}</div>
                    <div class="mobileScene-sceneIntro-imgPart clearfix">
                        <img :src="item.industryPicEntityList[0].requestPath" alt="" style="width:100%;">
                        <img :src="item.industryPicEntityList[3].requestPath" alt="" style="width:50%;float:left">
                        <img :src="item.industryPicEntityList[1].requestPath" alt="" style="width:50%;float:left">
                    </div>
                    <div class="mobileScene-sceneIntro-text">{{item.industryPicEntityList?item.industryPicEntityList[1].content:''}}</div>
                </div>
                <div class="mobileScene-relatedProducts">
                    <div class="mobileScene-relatedProducts-title">相关产品</div>
                    <div class="mobileScene-relatedProducts-listpart clearfix">
                        <div class="mobileScene-relatedProducts-list" v-for="product in item.industryProductDTOList" :key="product.uuid" @click="gotoproductDeatail(product)">
                            <div class="mobileScene-relatedProducts-list-img">
                                <img style="width:65%" :src="product.productInfo?product.productInfo.productUrl:''" alt="产品图">
                            </div>
                            <div class="mobileScene-relatedProducts-list-text">{{product.productInfo?product.productInfo.productName:''}}</div>
                        </div>
                    </div>
                </div>
                <div class="mobileScene-softwareService"  v-show="item.industrySoftwareDTOList!==undefined&&item.industrySoftwareDTOList!==null&&item.industrySoftwareDTOList.length>0">
                    <div class="mobileScene-softwareService-title">软件服务</div>
                    <div v-for="soft in item.industrySoftwareDTOList" :key="soft.uuid">
                        <div class="mobileScene-softwareService-img">
                            <img style="width: 100%;"  :src="soft.softwareInfo?soft.softwareInfo.picUrl:''" alt="软件图">
                        </div>
                        <div class="mobileScene-softwareService-desc">{{soft.softwareInfo?soft.softwareInfo.softName:''}}</div>
                    </div>
                </div>
                <div class="mobileScene-typicalCase" v-show="item.caseContent!==undefined&&item.caseContent!==''">
                    <div class="mobileScene-typicalCase-title">典型案例</div>
                    <div class="mobileScene-typicalCase-list" v-for="(typicalCaseItem,index) in item.caseContent.split(',')" :key="index">{{typicalCaseItem}}</div>
                </div>
            </div>

            <home-foot></home-foot>
        </div>



        <!-- PC端 -->
        <div class="mobileScene hidden-sm-and-down">
            <div class="scenetop clearfix">
                <div class="sceneTopList" v-for="(item,i) in prolist" :key="item.uuid" :style="{width:(100/prolist.length)+'%'}" @click="changeScene(item,i)">
                    <div :class="[industryType===item.industryType?'sceneActive':'sceneNormal']"></div>
                    <img :src="item.industryPicEntityList?item.industryPicEntityList[1].requestPath:''" alt="行业图">
                    <div class="sceneTopList-title">
                        <div>{{item.title}}</div>
                        <div>{{item.industryPicEntityList?item.industryPicEntityList[1].content:''}}</div>
                    </div>
                </div>
            </div>
            <div class="scenemain col-md-90" v-for="(item,index) in proChildList" :key="item.uuid">
                <div class="scenemain-title">{{item.title}}</div>
                <div class="scenemain-imgpart">
                    <img :src="item.industryPicEntityList[0].requestPath" alt="" style="width:100%;float: none;">
                    <div class="clearfix" :style="{position: 'relative',background: curBgColor}">
                        <img :src="item.industryPicEntityList[1].requestPath"  :style="{float:index%2!==0?'left':'right'}"  alt="" style="">
                        <div class="scenemain-imgpart-div" :style="{right:index%2!==0?'0':'auto'}">
                            <div class="scenemain-imgpart-divdesc">
                                <div>{{item.industryPicEntityList[0].content}}</div>
                                <div style="width:40px;margin-top: 10px;height: 2px;background: #fff;"></div>
                            </div>
                        </div>
                    </div>
                    <img :src="item.industryPicEntityList[2].requestPath" alt="">
                    <img :src="item.industryPicEntityList[3].requestPath" alt="">
                </div>
                <div class="scenemain-productpart">
                    <div v-if="isEn== '0'" class="scenemain-productpart-title">相关产品</div>
                    <div v-else-if="isEn== '1'" class="scenemain-productpart-title">Related products</div>
                    <div class="scenemain-productpart-list clearfix">
                        <div class="scenemain-productpart-listitem" v-for="product in item.industryProductDTOList" :key="product.uuid" @click="go_product_info(product)" >
                            <div class="scenemain-productpart-listitemimg">
                                <img :src="product.productInfo?product.productInfo.productUrl:''" alt="产品图">
                            </div>
                            <div class="scenemain-productpart-listdesc">{{product.productInfo?product.productInfo.productName:''}}</div>
                        </div>
                    </div>
                </div>
                <div class="scenemain-morePart clearfix">
                    <div class="scenemain-morePart-left clearfix" v-show="item.industrySoftwareDTOList!==undefined&&item.industrySoftwareDTOList!==null&&item.industrySoftwareDTOList.length>0">
                        <div v-if="isEn== '0'" class="scenemain-morePart-title">软件服务</div>
                        <div v-else-if="isEn== '1'" class="scenemain-morePart-title">Software service</div>
                        <div v-for="soft in item.industrySoftwareDTOList" :key="soft.uuid" class="scenemain-morePart-left-content">
                            <div class="scenemain-morePart-img">
                                <img :src="soft.softwareInfo?soft.softwareInfo.picUrl:''" alt="软件图">
                            </div>
                            <div class="scenemain-morePart-imgdesc">{{soft.softwareInfo?soft.softwareInfo.softName:''}}</div>
                        </div>
                    </div>
                    <div class="scenemain-morePart-right" v-show="item.caseContent!==undefined&&item.caseContent!==''">
                         <div v-if="isEn== '0'" class="scenemain-morePart-title">典型案例</div>
                         <div v-else-if="isEn== '1'" class="scenemain-morePart-title">Typical instance</div>
                        <div class="scenemain-morePart-list">
                            <div class="scenemain-morePart-listitem" v-for="(typicalCaseItem,index) in item.caseContent.split(',')" :key="index">{{typicalCaseItem}}</div>
                        </div>
                    </div>
                </div>

            </div>
            <home-foot></home-foot>
        </div>
    </div>

</template>
<script>
import HomeFoot from "@/components/HomeFoot";
export default {
    name:"mobileScene",
    components:{
        HomeFoot
    },
    data(){
        return {
            industryType:"",
            prolist:[],
            proChildList:[],
            prolistBgArr:['#22ac37','#24b5c4','#0075eb','#f87400','#23b5c6'],
            curBgColor:'#22ac37',
            isEn:'0',
        }
    },
  created() {
    this.isEn = ('1' ==sessionStorage.getItem("isEn")? sessionStorage.getItem("isEn") : '0');
  },
  methods:{
        changeScene(item,i){//切换行业
            var industryType=item.industryType
            this.industryType=item.industryType
            this.curBgColor=this.prolistBgArr[i]
            this.$router.push(`/mobileScene/${industryType}`);
        },
        go_product_info(product){//去pc端产品详情页
            var type=product.websiteProductDTO?product.websiteProductDTO.webModel:'A'
            var id=product.productUuid
            this.$router.push(`/productinfo${type}/${id}`);
        },
        gotoproductDeatail(product){//去移动端产品详情页
            var type=product.productInfo.webModel
            var id=product.productInfo.uuid
            this.$router.push(`/movingEnd/${id}`);
        },
        toscroll_top(tow){
            $('.mobileScene-page').animate({ scrollTop:0 }, 600);
        },
        getPro(){//获取行业方案
          let isEn = ('1' == sessionStorage.getItem("isEn") ? '1':'0');
            axios.get(`${window.$server_config.VUE_APP_WEBSITE_API }outer/industry/list?isEn=`+isEn).then(response => {
                var res=response.data
                if(res.code=== 200){
                    var prolist=res.data
                    if(prolist.length>5){//大于5个后只显示前5个
                        this.prolist=prolist.slice(0,5)
                    }else{
                        this.prolist=prolist
                    }
                    var index= this.prolist.findIndex(item=>item.industryType === this.industryType)
                    this.curBgColor=this.prolistBgArr[index]
                }else{
                    this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
                }
            })
        },
        getProChild(){//获取行业子类
            var data={industryType:this.industryType}
            axios.post(`${window.$server_config.VUE_APP_WEBSITE_API }outer/industry/getChildListByType`,null,{
                params:data
            }).then(response => {
                var res=response.data
                if(res.code=== 200){
                    var proChildList=res.data
                    this.proChildList=proChildList
                }else{
                    this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
                }
            })
        }
    },

    mounted(){
        this.industryType=this.$route.params.scene
        this.getPro()
        this.getProChild()
    },
    watch: {
        $route(to, from){
            this.toscroll_top(to);
            this.industryType=this.$route.params.scene
            this.getProChild()
        },
    }
}
</script>
<style scoped>
  .mobileScene-page{
        padding-top:65px;
        box-sizing: border-box;
        overflow: auto;
  }
    .scenetop{
        width:100%;
        height:600px;
    }
    .sceneTopList{
        float: left;
        width: 20%;
        position: relative;
        cursor: pointer;
        height: 100%;
        overflow: hidden;
    }
    .sceneTopList>div{
        position: absolute;
        width: 100%;
    }
    .sceneTopList img{
        width:100%;
        min-width: 380px;
        min-height: 600px;
        position: absolute;
        top: 0;
    }

    .sceneTopList-title{
        position: absolute;
        left: 10%;
        bottom: 10%;
        color: #fff;
        z-index: 4;
        max-width: 80%;
        text-align: justify;
        word-break: break-all;
    }
    .sceneTopList-title div:first-child{
        font-size: 24px;
        font-weight: 600;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        line-clamp: 4;
        -webkit-box-orient: vertical;
    }
     .sceneTopList-title div:last-child{
        font-size: 18px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 13;
        line-clamp: 13;
        -webkit-box-orient: vertical;
    }
    .sceneActive{
        background: #000;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 3;
    }
    .sceneNormal{
        background: #000;
        position: absolute;
        top: 0;
        width: 100%;
        height:100%;
        z-index: 3;
        opacity: 0.45;
    }

    .scenemain{
        margin: 0 auto;
        margin-top: 78px;
        margin-bottom: 80px;
        padding: 30px 0 0;
    }
    .scenemain-title{
        text-align: center;
        font-size:30px;
        color: #2c2c2c;
        font-weight: 600;
    }
    .scenemain-imgpart{
        margin:50px auto 0;
        overflow: hidden;
    }
    .scenemain-imgpart img{
        float: left;
        width:50%;
    }
    .scenemain-imgpart-div{
        width:50%;
        height:100%;
        float:left;
        color: #fff;
        text-align: left;
        font-size: 16px;
        position: absolute;
        line-height: 32px;
    }
    .scenemain-imgpart-divdesc{
        font-size: 20px;
        line-height: 36px;
        width: 100%;
        padding:0 10%;
        top: 50%;
        transform: translateY(-50%);
        position: absolute;
        text-align: justify;
    }
    .scenemain-imgpart-divdesc>div:nth-child(1){
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 7;
        line-clamp: 7;
        -webkit-box-orient: vertical;
    }
    .scenemain-productpart{
        padding-bottom: 30px;
        padding-left: 80px;
        padding-top: 50px;
        background: #FAFAFA;
    }
    .scenemain-productpart-title{
        font-size: 24px;
        margin:0 auto;
        margin-bottom: 20px;
        font-weight: 600;
    }
    .scenemain-productpart-list{
        background: #FAFAFA;
    }
    .scenemain-productpart-listitem{
        display: inline-block;
        color: #2c2c2c;
        width: 14%;
        margin: 0 auto;
        text-align: center;
        min-height: 165px;
        padding: 20px 10px;
        cursor: pointer;
        animation: tosmaill 0.2s;
        vertical-align: text-top;
    }
    .scenemain-productpart-listitem:hover{
        animation: tobig 0.2s;
        transform: scale(1.05)
    }
    @keyframes tobig
    {
        from { transform: scale(1)}
        to {   transform: scale(1.05)}
    }
    @keyframes tosmaill
    {
        from { transform: scale(1.05)}
        to {   transform: scale(1)}
    }
    .scenemain-productpart-listitemimg{
        margin-bottom: 10px;
    }
    .scenemain-productpart-listitemimg img{
        width: 80px;
    }
    .scenemain-productpart-listdesc{
        margin-top: 10px;
        font-size: 14px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        color: #131313;
        line-height: 20px;
        word-break: break-all;
    }
    .scenemain-morePart{
        margin:0 auto;
        padding: 0 0 72px 80px;
        background: #FAFAFA;
    }
    .scenemain-morePart-left{
        float: left;
        width: 48%;
        height: 100%;
    }
    .scenemain-morePart-right{
        float: left;
        width: 52%;
        height: 100%;
    }
    .scenemain-morePart-title{
        font-size: 24px;
        margin-bottom:20px;
        font-weight: 600;
    }
    .scenemain-morePart-right .scenemain-morePart-title{
        margin-bottom: 10px;
    }
    .scenemain-morePart-img{
        width: 250px;
    }
    .scenemain-morePart-img img{
        width: 100%;
        height:164px;
        margin-bottom:10px;
    }
    .scenemain-morePart-imgdesc,.scenemain-morePart-listitem{
        font-size: 14px;
        color: #131313;
        line-height: 28px;
        word-break: break-all;
        text-align: justify;
    }
    .scenemain-morePart-imgdesc{display: inline-block;margin-bottom:10px;}
    .scenemain-morePart-listitem{ padding-right:20px;}
    .scenemain-morePart-left-content{
        float: left;
        width: 250px;
        margin-right:20px;
        /* text-align: center; */
    }


    @media only screen and (max-width:991px) {
        .mobileScene-page{
            padding-top:50px;
        }
        .mobileScene-scene{
            width:100%;
        }
        .mobileScene-scene-part{
            width:100%;
            position: relative;
        }
        .product-title{
            position: absolute;
            z-index: 1;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            color: #fff;
            text-align: center;
            width:90%;
            margin: 0 auto;
        }
        .product-title>div:nth-child(1){
            font-size: 20px;
            line-height: 20px;
            margin-bottom: 14px;
            font-weight: 600;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        .product-title>div:nth-child(2){
            font-size: 14px;
            line-height: 14px;
            display: inline-block;
            text-align: justify;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-inline-box;
            -webkit-line-clamp: 4;
            line-clamp: 4;
            -webkit-box-orient: vertical;
        }
        .mobileScene-main{
            padding:20px 5% 15px;
        }
        .mobileScene-sceneIntro{
            margin-bottom: 20px;
        }
        .mobileScene-sceneIntro-title{
            font-size: 18px;
            font-weight: 600;
            color: #202020;
            margin-bottom:10px;
        }
        .mobileScene-sceneIntro-text{
            font-size: 14px;
            line-height: 25px;
            color: #2C2C2C;
            text-align: justify;
        }
        .mobileScene-sceneIntro-imgPart{
            width:100%;
            margin:20px 0;
        }
        .mobileScene-relatedProducts{
            margin-bottom: 20px;
        }
        .mobileScene-relatedProducts-title{
            font-weight: 600;
            font-size: 16px;
            color: #202020;
            margin-bottom: 10px;
        }
        .mobileScene-relatedProducts-listpart{display: flex;flex-wrap: wrap;align-items: baseline;justify-content: space-between;}
        .mobileScene-relatedProducts-list{
            width: 33.33%;
            float: left;
            text-align: center;
            margin-bottom:10px;
        }
        .mobileScene-relatedProducts-list-img{
            width:100%;
            margin-bottom:5px;
        }
        .mobileScene-relatedProducts-list-text{
            width: 75%;
            margin: 0 auto;
            font-size: 14px;
            color: #131313;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-all;
        }
        .mobileScene-softwareService{
             width: 100%;
             margin-bottom: 20px;
             text-align: center;
        }
        .mobileScene-typicalCase{
            width: 100%;
        }
        .mobileScene-softwareService-title,.mobileScene-typicalCase-title{
            font-size: 16px;
            font-weight: 600;
            color: #202020;
            margin-bottom:15px;
            text-align: left;
        }
        .mobileScene-softwareService-img{
            width: 100%;
        }
        .mobileScene-softwareService-desc{
            margin:10px 0;
            font-size: 14px;
            color: #131313;
            text-align: justify;
            display: inline-block;
        }
        .mobileScene-typicalCase-list{
            font-size: 14px;
            line-height: 25px;
            color: #2C2C2C;
        }
    }


</style>

<style lang="less" scoped>
    .sceneTopList{
        img{transform:scale(1);transition:all .4s linear}
    }
    .sceneTopList:hover{
        img{transform:scale(1.1);transition:all .4s linear}
    }
</style>



// WEBPACK FOOTER //
// src/views/mobileScene.vue